export const CONTRACT_SIGN_TYPES = {
  DIA: 'diia',
  SMS: 'sms',
  EMAIL: 'email',
  PAPER: 'paper',
};
